import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorGuiaList } from "./components/list";
import { ReceptorFactura, validarReceptor } from "../../facturas/edit/componentes/receptorfactura";
import { DireccionFacturacionComponent } from "./direccionfacturaciononline";
import { validar } from "./resumen";

interface Props {
    items: models.GuiaDTO[];
    FolioGuia: string;
    esFacturada: boolean;
    onFacturar: () => void;
    facturaOnline: models.FacturacionOnline;
    onChange: (x: models.FacturacionOnline) => void;
}

interface State {
    seleccion: string[];
}

class SeleccionGuiasNoRX extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { seleccion: props.esFacturada ? [] : [props.FolioGuia] };
    }


    facturaOnline = (props: Props) => props.facturaOnline;
    errors = createSelectorRx(this.facturaOnline, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));

    haySeleccionadas = (x: State) => x.seleccion.length > 0;
    items = (x: Props) => x.items;
    hayGuias = createSelectorRx(this.items, (guias) => guias.length > 0);
    receptorFactura = (props: Props) => props.facturaOnline.Receptor;
    correoFacturacion = (props: Props) => props.facturaOnline.CorreoFacturacion;

    onFacturarGuias = async () => {
        if (await kea.yesno("¿Facturar estas guías?")) {
            const folios = this.state.seleccion;
            const receptor = this.props.facturaOnline
            var params = { ...receptor, Folios: folios } as models.FacturacionOnline
            var idFactura = await resources.FacturacionGuia.FacturarGuiasOnline(params);
            await this.props.onFacturar();
            await kea.message("Guías facturadas");
        }
    }

    private onReceptorChange = async (x: models.ReceptorFactura) => {
        const viejo = this.props.facturaOnline;
        const cambio: Partial<models.FacturacionOnline> = { Receptor: x }
        const nuevo = { ...viejo, ...cambio };
        if (this.props.onChange)
            await this.props.onChange(nuevo);
    }

    private onCorreoChange = async (x: string) => {
        const viejo = this.props.facturaOnline;
        const cambio: Partial<models.FacturacionOnline> = { CorreoFacturacion: x }
        const nuevo = { ...viejo, ...cambio };
        if (this.props.onChange)
            await this.props.onChange(nuevo);
    }

    onSeleccionar = (value: string[]) => new Promise<void>(resolve => this.setState({ seleccion: value }, resolve));

    render() {
        const items = this.items(this.props);
        const hayGuias = this.hayGuias(this.props);
        const hasError = this.hasError(this.props);

        const haySeleccionadas = this.haySeleccionadas(this.state);
        const receptorFactura = this.receptorFactura(this.props);
        const correoFacturacion = this.correoFacturacion(this.props);
        const facturaOnline = this.facturaOnline(this.props);

        return (
            <div>
                <kea.Title titulo={"Seleccionar guías"} >
                    <kea.Button style="success" children="Facturar guias" onClick={this.onFacturarGuias} disabled={!haySeleccionadas || !hayGuias || hasError} />
                </kea.Title>
                {
                    !hayGuias ?
                        <div className="alert alert-info">
                            <label>No hay guías que concuerden con los datos agregados</label>
                            <br />
                            Verifiqué los datos de busqueda de <b>facturación</b>
                        </div> : <div>
                            {kea.autogrid(6, [
                                <ReceptorFactura value={receptorFactura} readonly={false} onChange={this.onReceptorChange} />,
                                <kea.Text value={correoFacturacion} onChange={this.onCorreoChange} label="Correo facturación:" />
                            ])}
                            <div className="row">
                                <div className="col-md-12">
                                    <DireccionFacturacionComponent value={facturaOnline} onChange={this.props.onChange} />
                                </div>
                            </div>,
                            <MultiselectorGuiaList value={this.state.seleccion} onChange={this.onSeleccionar} items={items} hideBusqueda />
                        </div>
                }
            </div>
        )
    }
}

export const SeleccionGuiasRX = componentToRx(SeleccionGuiasNoRX);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/selector.tsx